import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconProspector = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_355_6328)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M1.21892 36.833L4.33424 33.7177C4.47485 33.5771 4.66546 33.499 4.86544 33.499H5.37476C4.51235 32.396 3.9999 31.0086 3.9999 29.4994C3.9999 25.9091 6.90899 23 10.4993 23C14.0895 23 16.9986 25.9091 16.9986 29.4994C16.9986 33.0896 14.0895 35.9987 10.4993 35.9987C8.99003 35.9987 7.60267 35.4863 6.49965 34.6239V35.1332C6.49965 35.3332 6.42153 35.5238 6.28092 35.6644L3.1656 38.7797C2.87188 39.0734 2.39693 39.0734 2.10633 38.7797L1.22204 37.8954C0.92832 37.6017 0.92832 37.1267 1.21892 36.833ZM10.4993 33.499C12.7084 33.499 14.4989 31.7116 14.4989 29.4994C14.4989 27.2902 12.7115 25.4998 10.4993 25.4998C8.2901 25.4998 6.49965 27.2871 6.49965 29.4994C6.49965 31.7085 8.28698 33.499 10.4993 33.499Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M27.2422 25C27.4062 23.4062 27.5 21.7344 27.5 20C27.5 18.2656 27.4141 16.5938 27.2422 15H12.7656C12.6016 16.5938 12.5078 18.2656 12.5078 20C12.5078 20.106 12.5081 20.2118 12.5088 20.3173C15.132 20.995 17.3379 22.7106 18.6622 25H27.2422Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.6309 37.4855C18.6975 35.6536 20 32.9789 20 30C20 29.1368 19.8906 28.299 19.685 27.5H26.8984C26.4219 30.3438 25.6875 32.8594 24.7891 34.8906C23.9688 36.7344 23.0547 38.0703 22.1719 38.9141C21.2969 39.75 20.5703 40 20 40C19.4297 40 18.7031 39.75 17.8281 38.9219C17.4316 38.5429 17.0287 38.0646 16.6309 37.4855Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.33782 25H0.632812C0.21875 23.3984 0 21.7266 0 20C0 18.2734 0.21875 16.6016 0.632812 15H10.25C10.0859 16.6094 10 18.2812 10 20C6.29859 20 3.06687 22.011 1.33782 25Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M39.3672 15H29.75C29.9141 16.6094 30 18.2812 30 20C30 21.7188 29.9141 23.3906 29.75 25H39.3672C39.7812 23.3984 40 21.7266 40 20C40 18.2734 39.7812 16.6016 39.3672 15Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M29.4297 12.5H38.5391C36.2031 6.71094 31.2266 2.27344 25.1094 0.65625C27.1016 3.32812 28.6484 7.50781 29.4297 12.5Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.2109 5.10156C14.3125 7.14063 13.5781 9.65625 13.1016 12.5H26.8984C26.4219 9.64844 25.6953 7.13281 24.7891 5.10156C23.9688 3.25781 23.0547 1.92188 22.1719 1.07812C21.2969 0.25 20.5703 0 20 0C19.4297 0 18.7031 0.25 17.8281 1.07812C16.9453 1.92188 16.0312 3.25781 15.2109 5.10156Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.45312 12.5H10.5703C11.3516 7.50781 12.8984 3.32812 14.8906 0.65625C8.76562 2.27344 3.79688 6.71094 1.45312 12.5Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M25.1172 39.3438C31.2344 37.7266 36.2031 33.2891 38.5469 27.5H29.4375C28.6484 32.4922 27.1094 36.6719 25.1172 39.3438Z",
				fill: "currentColor"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_355_6328",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			fill: "white"
		})
	}) })]
});
export default SvgIconProspector;
